module.exports = __webpack_public_path__ + "/content/skins/volvo/img/volvo-wordmark-black.svg";